/**
 * Form Navigation Component
 */

import React from 'react';
import Button from '../../../components/ui/Button';

export const FormNavigation = React.memo(({
  currentStep,
  loading,
  isEditMode,
  onPrevious,
  onSaveDraft,
  onNext,
  onPublish
}) => {
  const isLastStep = currentStep === 4;

  return (
    <div className="flex items-center justify-between pt-8 border-t border-border gap-4">
      <div>
        {currentStep > 1 && (
          <Button
            variant="outline"
            iconName="ChevronLeft"
            onClick={onPrevious}
            disabled={loading}
          >
            Previous
          </Button>
        )}
      </div>

      <div className="flex items-center space-x-4">
        <Button
          variant="outline"
          onClick={onSaveDraft}
          disabled={loading}
        >
          {isEditMode ? 'Save Changes' : 'Save as Draft'}
        </Button>

        {!isLastStep ? (
          <Button
            variant="primary"
            iconName="ChevronRight"
            iconPosition="right"
            onClick={onNext}
            disabled={loading}
          >
            Next
          </Button>
        ) : (
          <Button
            variant="primary"
            iconName="Send"
            onClick={onPublish}
            disabled={loading}
          >
            {loading
              ? isEditMode
                ? 'Updating...'
                : 'Publishing...'
              : isEditMode
              ? 'Update & Publish'
              : 'Publish Job'}
          </Button>
        )}
      </div>
    </div>
  );
});

FormNavigation.displayName = 'FormNavigation';
